// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"container-v_wrapper__mQ_L-"};